import { getProfilePresentation } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const Description = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const userid = info?.id;

  const { data: { presentation = '' } = {} } = useQuery(
    getProfilePresentation,
    {
      key: ['studentDescription', userid],
      variables: { id: userid },
      enabled: typeof userid !== 'undefined',
    }
  );

  return (
    <div className={cx(classes.container)}>
      <div className={cx(global.title, classes.title)}>
        <FormattedMessage id="student.profil.description.title" />
      </div>
      {!presentation?.length || presentation == '' ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <div className={css({ width: '100%' })}>
          <div className={classes.modifyLink}>{parse(presentation)}</div>
        </div>
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
  },
  modifyLink: {
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    color: '#152652',
    '& p': {
      marginBottom: 0,
    },
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
  },
});

Description.propTypes = {
  info: PropTypes.object,
};

export default Description;
